<template>
    <div class="row">
        <FormInput class="col-12" label="Nombre" name="Nombre" rules="required" v-model="voucher.name" />
        <FormInput class="col-6" label="Descuento (%)" name="Descuento (%)" rules="required" type="number" v-model="voucher.discount_percent" :disabled="voucher.discount_fixed != 0" />
        <FormInput class="col-6" label="Descuento (€)" name="Descuento (€)" rules="required" type="number" v-model="voucher.discount_fixed"  :disabled="voucher.discount_percent != 0" />
        <FormInput class="col-6" label="Código" name="Código" rules="required" v-model="voucher.code" />
        <FormInput class="col-6" label="Usos" name="Usos" rules="required" type="number" v-model="voucher.units" />

        <div class="col-12">
            <div class="form-group">
                <label for="temporada">Precios</label>
                <multiselect
                    v-model="voucher.prices"
                    placeholder="Precios"
                    label="descripcion"
                    track-by="id"
                    :options="entradas"
                    :multiple="true"
                ></multiselect>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            voucher: {
                type: Object,
                default: () => { return {}; },
            },
            event_id: {},
            session_id: {}
        },
        data() {
            return {
                entradas: [],
            }
        },
        created() {
            const params = {
                filters : {},
                evento_id: this.event_id,
                sesion_id: this.session_id
            };

            this.$store.dispatch(this.config.getVuexAlias('back.events.sesiones.show'), params).then(res => {
                this.entradas = res.data.data.entradas;
            });
        },

    }
</script>
